/// <reference path="../dts/Path2D.d.ts" />

import { Circle } from "./Circle"
import { NumPair, Point } from "../Misc/Utils"

export enum SelectionCircle{
    TOP_LEFT = 0,
    TOP_RIGHT,
    BOTTOM_RIGHT,
    BOTTOM_LEFT,
    ROTATION,
    TOP,
    RIGHT,
    BOTTOM,
    LEFT
}

export class SelectionBox{
    rectangle : Path2D = new Path2D()
    circle : Circle
    txPointRect : Path2D = new Path2D();

    fillColor = 'rgb(110,120,135)' //gray
    strokeColor = 'rgb(110,120,135)'
    radius = 5
    rectSize = 2
    txPointRectPositionChange: NumPair = [this.rectSize, this.rectSize*3];
    txPointRectDim: NumPair = [this.rectSize*2, this.rectSize*6];
    lineDashGrey = [5,5]
    lineDashWhite = [5,5]
    lineDashOffset = 5

    xy = [0,0]
    wh = [0,0]

    selCircleIndex : number//array id of circle selected in this.circles 0<=n<=4; 0-3 = scaling, 4 = rotation

    constructor(){
        this.circle = new Circle();
        this.selCircleIndex = -1;
    }

    draw(canvasCtx : CanvasRenderingContext2D, xy : Point, wh : Point) : void {
        this.xy = xy;
        this.wh = wh;

        this.rectangle = this.getRect();
        
        canvasCtx.strokeStyle = this.strokeColor;
        canvasCtx.setLineDash(this.lineDashGrey);
        canvasCtx.stroke(this.rectangle);

        canvasCtx.strokeStyle = 'white';
        canvasCtx.setLineDash(this.lineDashWhite);
        canvasCtx.lineDashOffset = this.lineDashOffset;
        canvasCtx.stroke(this.rectangle);

        canvasCtx.setLineDash([]);
        canvasCtx.lineDashOffset = 0;
        
        var topleft: Point = this.getSelectionCirclePoint(SelectionCircle.TOP_LEFT);
        var topright: Point  = this.getSelectionCirclePoint(SelectionCircle.TOP_RIGHT);
        var bottomleft: Point  = this.getSelectionCirclePoint(SelectionCircle.BOTTOM_LEFT);
        var bottomright: Point  = this.getSelectionCirclePoint(SelectionCircle.BOTTOM_RIGHT);
        var rotPos: Point = this.getSelectionCirclePoint(SelectionCircle.ROTATION);
        
        this.circle.draw(canvasCtx, topleft, this.radius, this.fillColor); 
        this.circle.draw(canvasCtx, topright, this.radius, this.fillColor);
        this.circle.draw(canvasCtx, bottomright, this.radius, this.fillColor);
        this.circle.draw(canvasCtx, bottomleft, this.radius, this.fillColor);
        this.circle.draw(canvasCtx, rotPos, this.radius, this.fillColor); //rotation selection circle
   
        var top: Point = this.getSelectionCirclePoint(SelectionCircle.TOP);
        var right: Point  = this.getSelectionCirclePoint(SelectionCircle.RIGHT);
        var bottom: Point  = this.getSelectionCirclePoint(SelectionCircle.BOTTOM);
        var left: Point  = this.getSelectionCirclePoint(SelectionCircle.LEFT);
        
        this.circle.draw(canvasCtx, top, this.radius, this.fillColor); 
        this.circle.draw(canvasCtx, right, this.radius, this.fillColor);
        this.circle.draw(canvasCtx, bottom, this.radius, this.fillColor);
        this.circle.draw(canvasCtx, left, this.radius, this.fillColor);
        

        /*canvasCtx.fillStyle = this.fillColor;
        canvasCtx.strokeStyle = 'white';
        this.drawTxPointRect(SelectionCircle.TOP, canvasCtx);
        this.drawTxPointRect(SelectionCircle.BOTTOM, canvasCtx);
        this.drawTxPointRect(SelectionCircle.LEFT, canvasCtx);
        this.drawTxPointRect(SelectionCircle.RIGHT, canvasCtx);*/
    }

    drawTxPointRect(selectionCircle: SelectionCircle, canvasCtx: CanvasRenderingContext2D){
        this.txPointRect = new Path2D();
        var point = this.getSelectionCirclePoint(selectionCircle);
        switch(selectionCircle){
            case SelectionCircle.RIGHT:
            case SelectionCircle.LEFT:
                this.txPointRect.rect(
                    point[0]-this.txPointRectPositionChange[0], 
                    point[1]-this.txPointRectPositionChange[1],
                    this.txPointRectDim[0], 
                    this.txPointRectDim[1]);
                break;
            case SelectionCircle.TOP:
            case SelectionCircle.BOTTOM:
                this.txPointRect.rect(
                    point[0]-this.txPointRectPositionChange[1], 
                    point[1]-this.txPointRectPositionChange[0],
                    this.txPointRectDim[1], 
                    this.txPointRectDim[0]);
                break;
        }
        canvasCtx.fill(this.txPointRect);
    }

    getSelectionCirclePoint(type: SelectionCircle): Point{
        var point: Point = [0,0]
        switch(type){
            case SelectionCircle.TOP_LEFT:
                point = [-this.wh[0]/2, -this.wh[1]/2];
            break;
            case SelectionCircle.TOP_RIGHT:
                point = [this.wh[0]/2, -this.wh[1]/2];
            break;
            case SelectionCircle.BOTTOM_RIGHT:
                point = [this.wh[0]/2, this.wh[1]/2];
            break;
            case SelectionCircle.BOTTOM_LEFT:
                point = [-this.wh[0]/2, this.wh[1]/2];
            break;
            case SelectionCircle.ROTATION:
                point = [0, (this.wh[1]/2)+20];
            break;
            case SelectionCircle.TOP:
                point = [0, -this.wh[1]/2];
            break;
            case SelectionCircle.RIGHT:
                point = [this.wh[0]/2, 0];
            break;
            case SelectionCircle.BOTTOM:
                point = [0, this.wh[1]/2];
            break;
            case SelectionCircle.LEFT:
                point = [-this.wh[0]/2, 0];
            break;
        }
        return point;    
    } 

    checkSelection(point : Point, wh:Point) : boolean{
        var index = -1;
        
        var topleft: Point = this.getSelectionCirclePoint(SelectionCircle.TOP_LEFT);
        var topright: Point  = this.getSelectionCirclePoint(SelectionCircle.TOP_RIGHT);
        var bottomleft: Point  = this.getSelectionCirclePoint(SelectionCircle.BOTTOM_LEFT);
        var bottomright: Point  = this.getSelectionCirclePoint(SelectionCircle.BOTTOM_RIGHT);
        var rotPos: Point = this.getSelectionCirclePoint(SelectionCircle.ROTATION);
        var top: Point = this.getSelectionCirclePoint(SelectionCircle.TOP);
        var right: Point  = this.getSelectionCirclePoint(SelectionCircle.RIGHT);
        var bottom: Point  = this.getSelectionCirclePoint(SelectionCircle.BOTTOM);
        var left: Point  = this.getSelectionCirclePoint(SelectionCircle.LEFT);
        
        if(this.circle.contains(point, topleft, this.radius))
            index = SelectionCircle.TOP_LEFT;
        else if(this.circle.contains(point, topright, this.radius))
            index = SelectionCircle.TOP_RIGHT;
        else if(this.circle.contains(point, bottomright, this.radius))
            index = SelectionCircle.BOTTOM_RIGHT;
        else if(this.circle.contains(point, bottomleft, this.radius))
            index = SelectionCircle.BOTTOM_LEFT;
        else if(this.circle.contains(point, rotPos, this.radius))
            index = SelectionCircle.ROTATION;  //rotation selection circle
        else if(this.circle.contains(point, top, this.radius))
            index = SelectionCircle.TOP;
        else if(this.circle.contains(point, right, this.radius))
            index = SelectionCircle.RIGHT;
        else if(this.circle.contains(point, bottom, this.radius))
            index = SelectionCircle.BOTTOM;
        else if(this.circle.contains(point, left, this.radius))
            index = SelectionCircle.LEFT;
        /*else if(this.txRectContains(SelectionCircle.TOP, point))
            index = SelectionCircle.TOP;
        else if(this.txRectContains(SelectionCircle.RIGHT, point))
            index = SelectionCircle.RIGHT;
        else if(this.txRectContains(SelectionCircle.BOTTOM, point))
            index = SelectionCircle.BOTTOM;
        else if(this.txRectContains(SelectionCircle.LEFT, point))
            index = SelectionCircle.LEFT;*/

        this.selCircleIndex = index;

        return this.isTransformPointSelected();
    }

    txRectContains(type: SelectionCircle, ptToCheck: Point): boolean{
        var point = this.getSelectionCirclePoint(type);
        switch(type){
            case SelectionCircle.RIGHT:
            case SelectionCircle.LEFT:
                return this.isInBounds(
                    [point[0]-this.txPointRectPositionChange[0], point[1]-this.txPointRectPositionChange[1]],
                    [this.txPointRectDim[0], this.txPointRectDim[1]], 
                    ptToCheck);
                break;
            case SelectionCircle.TOP:
            case SelectionCircle.BOTTOM:
                return this.isInBounds(
                    [point[0]-this.txPointRectPositionChange[1], point[1]-this.txPointRectPositionChange[0]],
                    [this.txPointRectDim[1], this.txPointRectDim[0]],
                    ptToCheck);
                break;
        }
        return false;
    }

    private isInBounds(xy: Point, wh: NumPair, point: Point): boolean{
        if(point[0] >= xy[0] && point[0]<= xy[0]+wh[0]){
            if(point[1] >= xy[1] && point[1]<= xy[1]+wh[1]){
                return true;
            }
        }
        return false;
    }

    getRect() : Path2D{
        var rect = new Path2D();
        rect.rect(-this.wh[0]/2, -this.wh[1]/2, this.wh[0], this.wh[1]);
        return rect;
    }

    isTransformPointSelected(){
        return this.selCircleIndex != -1 ? true : false ;
    }

    isScaling(){
        return (this.selCircleIndex >= SelectionCircle.TOP_LEFT && this.selCircleIndex <= SelectionCircle.BOTTOM_LEFT) 
        || (this.selCircleIndex >=SelectionCircle.TOP && this.selCircleIndex <= SelectionCircle.LEFT);
    }

    isRotation(){
        return this.selCircleIndex == SelectionCircle.ROTATION;
    }

    getTransformPointIndex(){
        return this.selCircleIndex;
    }

    setFillColor(color : string){
        if(color == "green"){
            this.fillColor = 'rgb(50,200,50)';
        }
    }
}